import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 13.83 14.51"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.54 3.2c.39.47.97.63 1.33.36.23-.17.32-.48.26-.81.22.03.43.1.68.2.12.04.27-.48.08-.5-2.08-.3-3.24 1.38-3.21 1.36.32-.24.59-.45.85-.61m1.2.19c-.28.22-.73.08-1.06-.27.43-.27.8-.4 1.2-.39.08.26.01.54-.14.66M.35 4.14a8.1 8.1 0 0 1 1.8-3.13C5.73-.51 10.36-.5 13.83 2.3 11.66 1.19 5.22 0 .35 4.14M.14 7.99a8.27 8.27 0 0 1-.07-2.58c2.55-2.59 6.35-4.29 10.34-3.46-2.18 0-7.42 1.5-10.27 6.03m1.36 3.19C1.08 10.58.73 9.93.48 9.23c1.51-3.2 4.42-5.99 8.34-6.6-1.95.74-6.01 3.73-7.32 8.53m2.46 2.29c-.6-.35-1.15-.79-1.63-1.28.52-3.38 2.59-6.92 5.89-8.76-.24.36-.36.78-.33 1.22-1.93 1.95-3.84 4.99-3.93 8.82m3.06 1.06c-.65-.09-1.28-.25-1.88-.48.02-3.06 1.01-6.7 2.82-8.93.1.39.29.79.6 1.19 1.43-1.68 3.07-2.87 5.12-3.39-2.79 1.06-7.12 4.43-6.65 11.61",
      style: {"fill":"#00265d","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MS-logo"}) } }